import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@nx-fe/services';

@Injectable()
export class RedirectGuard implements CanActivate {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate(): Promise<boolean> {
    return this.authenticationService
      .isAuthenticated()
      .then(data => {
        if (data.isAuth) {
          this.router.navigate(['/home']);
          return false;
        }
        return true;
      })
      .catch(() => {
        return true;
      });
  }
}
